// Angular
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

// Angular Material
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

// services
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'import-guest-dialog',
  templateUrl: './import-guest-dialog.component.html',
  styleUrls: ['./import-guest-dialog.component.scss'],
})
export class ImportGuestDialogComponent implements OnInit {
  private token: any;
  public form: FormGroup;
  public isOnline: boolean;
  public importError: any;
  public loading: boolean;

  constructor(private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) public guestToImport: any,
    fb: FormBuilder, private apiService: ApiService
    ) {
      this.form = fb.group({
        notes: [''],
        to_do: [false],
      });
    }

    async ngOnInit() {
      this.token = await this.apiService.getTokenFromDatabase();
      this.isOnline = navigator.onLine;
    }

    get valid() {
      return this.form.valid;
    }

    get value() {
      const formValue = this.form.value;
      formValue.open_id = this.guestToImport.open_id;
      formValue.guest_email = this.guestToImport.guest.guest.email;

      return formValue;
    }

    public async importGuest() {
      this.isOnline = navigator.onLine;
      this.importError = null;
      this.loading = true;
  
      try {
        const response = await this.apiService.importGuest(this.token, this.value);
        if(response.status === "success") {
          this.guestToImport.guest.imported = "manual_queued"; // Update local record
          this.dialog.closeAll();
        }
      } catch (error) {
        this.handleError(error);
      }
  
      this.loading = false;
    }

  private handleError(error: any) {
    if (error && error.error && error.error.message) {
      this.importError = error.error.message;
    } else {
      console.log(error);
    }

    if (this.isOnline === false) {
      this.importError = 'You must be online to import guests into the DeltaNET&reg;.';
    }
  }

  public cancel() {
    this.dialog.closeAll();
  }
}
